namespace SPA {
	export namespace Shop
	{
		import RealtorObjectModel = SPA.Realtor.RealtorObjectModel;
		export type IShopItems = "WFB" | "PLAN" | "BGFA" | "BKI" | "BELV" | "IMMOV" | "GRM" | "LRM" | "LAYOUT" | "CITYMAP" | "DEED" | "ER" | "PACKET" | "BRW";

		export class Page
		{
			private m_Modal: JQuery;
			private document: IDocument | null;
			private item: IShopItems | null;
			private m_Data: RealtorObjectModel|null;
			private m_ags: string = '';
			private Employee: object|null;
			private Callback?: (data: IDocument) => any;
			private hasPrice: boolean = false;
			private price: number = 0;

			public constructor(item: IDocument | IShopItems, data: RealtorObjectModel|null = null)
			{
				this.m_Modal = $('body > .modal');
				this.m_Modal.one('hide.bs.modal', (e) => {
					$('html').off('agschange');
				});
				if (typeof item === 'string') {
					this.item = item;
					this.document = null;
				} else {
					this.item = item.shop_item;
					this.document = item;
				}
				this.m_Data = data;
				// Für Schreibfaule
				// @see app/managers/authentication.ts #145
				this.Employee = app.getAuthenticationManager().getEmployee();

				this.Initialize();
			}

			public setCallback(callback: (data: IDocument) => any): void
			{
				this.Callback = callback;
			}

			private Initialize()
			{
				let title: string = '';
				let entry: string = '';
				let uploadInput: boolean = false;
				let body: JQuery = $('<p>Kein Inhalt</p>');

				switch (this.item) {
					case "BKI":
						title = "BelWertV BKI";
						entry = "Text fehlt.";
						break;
					case "BELV":
						title = "Bewertungen nach BelWertV";
						entry = "Text fehlt.";
						break;
					case "IMMOV":
						title = "Bewertungen nach ImmoWertV";
						entry = "Text fehlt.";
						break;
					case "GRM":
						title = "Bewertungen nach Ertragswertverfahren";
						entry = "Text fehlt.";
						break;
					case "PACKET":
						title = "Datenpaket";
						entry = "Über dieses Formular können Sie unser Datenpaket zum Angegebenen Objekt anfordern. " +
							"Wir senden Ihnen das Datenpaket dann per Email zu.";
						break;
					case "LAYOUT":
						title = "Bebauungsplan bestellen";
						entry = "Bitte geben Sie nachfolgend die Adresse an, für die Sie einen Auszug aus dem Bebauungsplan bestellen möchten. " +
							"Wir senden Ihnen ein ausdruckbares Exemplar nach Prüfung an die angegebene E-Mail Adresse zu.";
						break;
					case "LRM":
						title = "Liegenschaftskarte bestellen";
						entry = 'Bitte geben Sie nachfolgend die Adresse an, für die Sie eine Liegenschaftskarte bestellen möchten.'
							+ ' Wir senden Ihnen ein ausdruckbares Exemplar im Maßstab von 1:1.000 nach Prüfung an die angegebene'
							+ ' E-Mail Adresse.';
						break;
					case "ER":
						title = "Baulastenverzeichnis anfordern";
						entry = "Über dieses Formular können Sie einen Auszug aus dem Baulastenverzeichnis zum Angegebenen Objekt anfordern. Bitte"
							+ ' senden Sie uns anbei hierzu als Anlage einen schriftlichen und eigenhändig unterschriebenen Antrag.'
							+ ' <br><br>Wir bearbeiten ausschließlich Anfragen mit berechtigtem Interesse.';
						uploadInput = true;
						break;
					case "DEED":
						title = "Grundbuchauszug bestellen";
						entry = "Über dieses Formular können Sie einen Grundbuchauszug anfordern. " +
							"Bitte senden Sie uns anbei hierzu als Anlage eine schriftliche und eigenhändig vom Eigentümer unterschriebene Vollmacht zu. " +
							"Der Vordruck zur Bevollmächtigung steht als Download bereit.";
						uploadInput = true;
						break;
					case "CITYMAP":
						title = "Stadtpläne (Mikro-/Makrolage)";
						entry = "Bitte geben Sie nachfolgend die Adresse an, für die Sie einen Auszug aus dem Stadtplan zwecks Mikro- und Makrolage bestellen möchten. " +
							"Wir senden Ihnen ein ausdruckbares Exemplar nach Prüfung an die angegebene E-Mail Adresse zu.";
						break;
					case "PLAN":
						title = "Grundrisserstellung";
						entry = "Wir erstellen Ihnen nach Absprache einen professionellen Grundriss. " +
							"Geben Sie im Kommentarfeld an, wann Ihnen ein Vor-Ort Termin zeitlich am besten zusagt.";
						break;
					case "WFB":
						title = "Wohnflächenberechnung bestellen";
						entry = 'Wir erstellen Ihnen nach Absprache vor Ort eine professionelle Wohnflächen-Berechnung.'
							+ ' Geben Sie im Kommentarfeld an, wann Ihnen ein Vor-Ort Termin zeitlich am Besten zusagt.';
						uploadInput = false;
						break;
					case "BGFA":
						title = "Bruttogrundfläche nach Aufmaß";
						entry = "Wir führen nach Absprache eine professionelle Bruttogrundflächenermittlung nach Aufmaß durch. " +
							"Geben Sie im Kommentarfeld an, wann Ihnen ein Vor-Ort Termin zeitlich am besten zusagt.";
						break;
					case "BRW":
						title = "Bodenrichtwerte bestellen";
						entry = "Wir optimieren Ihre Dokumentenbeschaffung und Datenrecherche. Dabei garantieren wir Ihnen Aktualität, geringe Kosten und 24/7 Verfügbarkeit. "
							+ ' Mit einer Historie von über 10 Jahren erhalten Sie eine umfassende Auswertung.';
						break;
					default:
						alert('Dieser Artikel ist bald in unserem Shop verfügbar');
						return;
				}
				$('html').on('agschange', (e, ags) => {
					new Wollmilch.AJAX({
						url: 'price/getprice/' + this.item + "/" + ags,
						method: 'GET',
						on: {
							success: (text: string) => {
								const resp = JSON.parse(text);
								if (resp.success === true) {
									this.price = resp.data.b_price;
									this.hasPrice = true;

									if (this.item === "DEED" || this.item === "ER") {
										$('.mandateReq').prop('required', true);
									}
									$('.bPrice').text(resp.data.b_price + " € (inkl. MwSt)");
									this.m_Modal.find('.btn-primary').text('Jetzt kostenpflichtig bestellen');
								}
								if (resp.data.on_demand === true) {
									this.price = 0;
									this.hasPrice = false;

									if (this.item === "DEED" || this.item === "ER") {
										$('.mandateReq').removeAttr('required');
									}

									$('.bPrice').text("(Preis auf Anfrage)");
									this.m_Modal.find('.btn-primary').text('Jetzt Preis anfragen');
								}
							}
						}
					}, AJAXCallbase_e.SHOP).send();
				});
				body = this.buildModal(entry, uploadInput);
				this.m_Modal.find('.modal-title').text(title);
				this.m_Modal.find('.modal-body').empty().append(body);
				this.m_Modal.find('.btn-primary').text('Jetzt kostenpflichtig bestellen');
				this.m_Modal.modal('show');
			}

			private buildModal(entry: string = '', uploadInput: boolean = false): JQuery
			{
				const Employee: Wollmilch.EmployeeObject = app.getAuthenticationManager().getEmployee() as Wollmilch.EmployeeObject;
				const Company = app.getAuthenticationManager().getCompany();

				const email = this.getAddressByKind(Employee.Address, 'email');
				const phone = this.getAddressByKind(Employee.Address, 'cell');
				const mobile = this.getAddressByKind(Employee.Address, 'mobile');
				const CompanyAddress = this.getAddressByKind(Company.Address, 'headquarters');

				let shopData: { [name: string]: string } = {};
				if (this.m_Data !== null)
				{
					const obj_address: Wollmilch.PostalAddressObject = this.m_Data.Address;
					shopData = {
						street: obj_address.Street,
						housenumber: obj_address.HouseNumber,
						postalcode: obj_address.PostalCode,
						city: obj_address.City,
						state: obj_address.State || '',
						// ags: this.m_Data && this.m_Data.Address ? this.m_Data.AdvData.AGS || this.m_Data.AdvData.gms_id : ''
						ags: this.m_Data.Address.GMS !== null ? obj_address.GMS as string : ''

					};
					$('html').trigger('agschange', [shopData.ags]);
				}
				let objectnumberRow = ui.$$.div();
				let ObjectNumber = '';
				if (this.m_Data && this.m_Data.ObjectNumber)
				{
					ObjectNumber = this.m_Data.ObjectNumber;
					objectnumberRow = ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-sm-5')
							.append(ui.$$.label().addClass('control-label').text('Objekt-Nummer'))
							.append(ui.$$.input().addClass('form-control').attr({type: 'text', name: 'objectnumber', value: ObjectNumber, disabled: 'disabled'}))
						);
				}

				const address = new ui.base.BaseHTMLElement('div').addClass('row').attr('id', 'addressrow');
				const orderForm = new ui.Form.Form(
				{
					action: '',
					method: 'POST',
					notSwitchable: true,
					submit: () => {
						return;
					}
				});

				const disableAddress = this.m_Data !== null;
				const adr_list = SPA.gui.form.SimpleStyledPostalAddress(
					orderForm,
					address,
					'',
					shopData,
					"hidden",
					disableAddress
				);
				const $form = $('<form class="form-horizonal" id="modalOrderForm">')
					.append(`<p>${entry}</p>`)
					.append(ui.$$.div().addClass('row')
						.append('<div class="col-md-8"><h3 style="margin:0;">Objekt-Adresse</h3></div>')
						.append('<div class="col-md-4 text-right"><span class="bPrice text-success lead">---</span></div>')
					)
					.append(objectnumberRow)
					.append(address.Root())
					.append(ui.$$.div().addClass('row').append(`
							<h3 class="col-sm-12">Kontakt <small>(für Rückfragen)</small></h3>
						`))
					.append(ui.$$.div().addClass('row').append(`
							<div class="col-sm-4">
								<label class="control-label">Ihre E-Mail</label>
								<input class="form-control" type="email" name="email" value="${email.display ? email.display : ''}">
							</div>
							<div class="col-sm-4">
								<label class="control-label">Telefon (für Rückfragen)</label>
								<input class="form-control" type="text" name="phone" value="${phone.display ? phone.display : ''}">
							</div>
							<div class="col-sm-4">
								<label class="control-label">Mobil (für Rückfragen)</label>
								<input class="form-control" type="text" name="phone" value="${mobile.display ? mobile.display : ''}">
							</div>
						`))
					.append(ui.$$.div().addClass('row').append(`<h3 class="col-xs-12">Auftraggeber</h3>`))
					.append(ui.$$.div().addClass('row').append(`<div class="col-xs-6">
								<strong>${Company.Name} ${Company.LegalForm}</strong>
							</div>
							<div class="col-xs-6">
								<address>
									${CompanyAddress.Street ? CompanyAddress.Street : ''} ${CompanyAddress.HouseNumber ? CompanyAddress.HouseNumber : ''}<br>
									${CompanyAddress.PostalCode ? CompanyAddress.PostalCode : ''} ${CompanyAddress.City ? CompanyAddress.City : ''}<br>
									${CompanyAddress.State ? SPA.types.Address.State[CompanyAddress.State] : ''}
								</address>
							</div>
						`))
					.append(ui.$$.div().addClass('row').append(`
							<div class="col-sm-12">
								<label class="control-label">Ihre Nachricht an uns</label>
								<textarea class="form-control" rows="8" name="comment"></textarea>
							</div>
						`))
					.append(`<div id="shopUploadInput" class="row"></div>`)
					.append(ui.$$.div().addClass('row').append(`<label class="col-sm-12">
								<input type="checkbox" name="accept_tos" value="1" required />
								<span>Ich habe die <a href="agb.html" target="_blank">allgemeinen Geschäftsbedingungen (AGB)</a> gelesen und akzeptiert.</span>
							</label>
							<label class="col-sm-12">
								<input type="checkbox" name="accept_gdpr" value="1" required />
								<span>Ich habe die <a href="datenschutz.html" target="_blank">Datenschutzbestimmungen</a> gelesen und akzeptiert.</span>
							</label>
							<label class="col-sm-12">
								<input type="checkbox" name="accept_gdpr" value="1" required />
								<span>Ich habe die <a href="${app.getRemotePath()}Preisliste_201909.pdf" target="_blank">Preisliste</a> gelesen und akzeptiert.</span>
							</label>`))
					.append(ui.$$.div().addClass('row').append(`<p class="col-sm-12">Bitte beachten Sie, dass die hier bestellten Leistungen aktuell nicht automatisch im Makler-Tool hinterlegt werden.</p>`))
					.append(`<input type="hidden" name="company.name" value="${Company.Name} ${Company.LegalForm}" />
						<input type="hidden" name="company.street" value="${CompanyAddress.Street}" />
						<input type="hidden" name="company.housenumber" value="${CompanyAddress.HouseNumber}" />
						<input type="hidden" name="company.postalcode" value="${CompanyAddress.PostalCode}" />
						<input type="hidden" name="company.city" value="${CompanyAddress.City}" />
						<input type="hidden" name="company.state" value="${CompanyAddress.State}" />
						<input type="hidden" name="company.country" value="DE" />
						<input type="hidden" name="object_number" value="${ObjectNumber}" />
						<input type="hidden" name="order" value="${this.item}" />`)
					.append(ui.$$.div().addClass('row').append(`<div class="col-md-12 text-right"><span class="bPrice text-success lead">---</span></div>`));

				if (uploadInput) {
					let mandateURL: string = '';
					if (this.item === "DEED") {
						mandateURL = 'Vollmacht_Grundbuch.pdf';
					} else if (this.item === "ER") {
						mandateURL = 'Vollmacht_Baulastenverzeichnis.pdf';
					}
					$form.find('#shopUploadInput').append(`
						<label class="control-label col-sm-3">Vollmacht hochladen:</label>
						<a class="col-sm-9" href="${app.getRemotePath()}${mandateURL}" download target="_blank">
							<i class="fa fa-file-pdf-o btn-danger" style="margin-right: 5px;"></i> Vordruck zum Antrag herunterladen
						</a>
						<div class="col-sm-9 col-sm-offset-3">
							<input class="form-control mandateReq" type="file" name="file" value="" required/>
						</div>`
					);
				}
				this.m_Modal.find('.btn-primary').attr('form', 'modalOrderForm');

				this.m_Modal.off('submit');
				this.m_Modal.on('submit', 'form', (e) => {
					e.preventDefault();
					const fData = new FormData(e.currentTarget);
					// Add price
					fData.append('price', this.price as unknown as string);
					// Add disabled field data
					fData.append('ags', e.currentTarget.ags.value);
					new Wollmilch.AJAX({
						url: 'service/order', // + this.document.default_id,
						method: 'POST',
						data: fData,
						on: {
							success: (text: string) => {
								const obj = JSON.parse(text);
								if (obj.success === true) {
									this.m_Modal.modal('hide');

									if (this.Callback) {
										this.Callback(obj.data);
									} else {
										if (this.price === 0) {
											alert('Vielen Dank für Ihre Preisanfrage.\r\nWir melden uns schnellstmöglich bei Ihnen.');
										} else {
											alert('Vielen Dank für Ihre Bestellung.\r\nWir melden uns schnellstmöglich bei Ihnen.');
										}
									}
								}
							}
						}
					}, AJAXCallbase_e.SHOP).send();
				});

				return $form;
			}

			private getAddressByKind(contacts: any, kindOf: string)
			{
				for (const contact of contacts)
				{
					if (contact.KindOf) {
						if (contact.KindOf.toLowerCase() === kindOf.toLowerCase())
						{
							return contact;
						}
					}
				}

				return false;
			}
		}
	}
}
